<template>
<div class="spinner">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
</div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    created() {
    }
})

</script>